import { type QrynRetentionPolicyTier } from 'api-client'

export function getTierName(tier: QrynRetentionPolicyTier, index: number, numOfTiers: number) {
  if (index === 0) return `First ${tier.endingUnit} GBs`
  if (index === numOfTiers - 1) return `After ${tier.startingUnit} GBs`
  return `From ${tier.startingUnit} to ${tier.endingUnit} GBs`
}
